import { type Ref, watch, ref, computed, type ComputedRef } from 'vue'
import { useAuthStore } from '@/stores/authStore'
import { loadFromStorage, numberListFormatter } from '@/utils'
import type { ApiKeyType } from '@/services/api-keys-v2-service/types'
import { isNull } from 'lodash'

export const useProfiles = (
  bunchCacheKey: Ref<string> | ComputedRef<string | null> | null,
  mode: ApiKeyType,
) => {
  const enabledProfiles = ref<number[]>([])
  const authStore = useAuthStore()
  const profiles = computed(() => {
    if (!authStore.authorized) {
      return []
    }
    return mode == 'cex_cex' ? authStore.profiles.cex_cex : authStore.profiles.dex_cex
  })

  const profilesMax = computed(() => profiles.value.length)

  const cacheKey = computed(() => {
    const modeStr = mode == 'cex_cex' ? 'profiles' : 'profiles_dex'
    if (isNull(bunchCacheKey)) {
      return modeStr
    }
    if (!bunchCacheKey.value || !profiles.value.length) {
      return null
    }
    return `${modeStr}/${bunchCacheKey.value}`.toLowerCase()
  })

  const toggleProfile = (idx: number) => {
    const lidx = enabledProfiles.value.indexOf(idx)
    if (lidx == -1) {
      enabledProfiles.value.push(idx)
    } else {
      enabledProfiles.value.splice(lidx, 1)
    }
  }

  watch(
    enabledProfiles,
    (v: number[]) => {
      if (!cacheKey.value) {
        return
      }
      localStorage.setItem(cacheKey.value, v.join(';'))
    },
    { deep: true },
  )

  watch(
    cacheKey,
    (v) => {
      if (!v || !profiles.value.length) {
        return
      }
      enabledProfiles.value = loadFromStorage<number[]>(v, numberListFormatter, [0]).filter((x) => {
        return profiles.value.includes(x)
      })
    },
    { immediate: true },
  )

  return { toggleProfile, enabledProfiles, profilesMax, profiles }
}
